import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Refund() {
    return (
        <Container className="mb-5">
            <Row>
                <Col>
                    <h1 className="fs-4 fw-bold mb-4">Условия возврата</h1>
                    <p><strong>Товары надлежащего качества</strong></p>
                    <p>Вернуть товар можно в течение 7 дней с даты получения заказа.</p>
                    <p>Мы принимаем к возврату товары, которые не использовались, сохранили товарный вид и потребительские свойства, со всеми заводскими пломбами и ярлыками.</p>
                    <p>Для возврата товара надлежащего качества нужен кассовый чек или номер заказа.</p>
                    <p>Согласно ст. 25 Закона РФ «О защите прав потребителей» мы не принимаем к возврату товар, если он входит в Перечень непродовольственных товаров надлежащего качества, не подлежащих обмену. Перечень утверждён Постановлением Правительства РФ от 31 декабря 2020 г. № 2463.</p>
                    <p>Если вы не уверены, что ваш товар можно вернуть, напишите в клиентскую поддержку на сайте.</p>

                    <p><strong>Товары ненадлежащего качества</strong></p>
                    <p>Если вы обнаружили брак или другой недостаток в товаре, вы можете обратиться к нам в чат или по номеру телефона +7 927 533-25-85.</p>
                    <p>До приезда в магазин рекомендуем вам отправить обращение в клиентскую поддержку на сайте. В обращении опишите недостатки товара и приложите фотографии.
                        В этом случае мы заранее сообщим вам о предварительном решении по вашему обращению.</p>
                    <p>Для возврата вам понадобится:</p>
                    <p>кассовый чек или другой документ, подтверждающий оплату.</p>
                    <p>Возврат товаров на гарантии и без установленного гарантийного срока происходит по разным правилам.</p>
                </Col>
            </Row>
        </Container>
    );
}

export default Refund;